<template>
  <section class="list">
    <div class="row">
      <article
        class="card lomo-card"
        v-for="lomo in lomos"
        :key="lomo"
        @click="selectLomo(lomo)"
      >
        <div class="lomo-body">
          <h3>Lomo {{ lomo }}</h3>
          <p class="lomo-count">
            {{ countZones(lomo) }} zona{{ countZones(lomo) !== 1 ? "s" : "" }}
          </p>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "ListLomos",

  props: {
    finca: {
      type: Object,
      required: true,
    },
  },

  computed: {
    lomos() {
      if (!this.finca || !Array.isArray(this.finca.zones)) return [];
      const nums = this.finca.zones
        .map((z) => z.lomo)
        .filter((l) => l !== null && l !== undefined);
      return [...new Set(nums)].sort((a, b) => a - b);
    },
  },

  methods: {
    countZones(lomo) {
      if (!this.finca || !Array.isArray(this.finca.zones)) return 0;
      return this.finca.zones.filter((z) => z.lomo === lomo).length;
    },

    selectLomo(lomo) {
      this.$root.$emit("lomo", lomo);
    },
  },
};
</script>

<style scoped>
.lomo-card {
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.lomo-body {
  padding: 20px 16px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: rgba(255, 255, 255, 0.55);
}

.lomo-body h3 {
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: 700;
  color: #107631;
  padding: 0;
  text-transform: none;
}

.lomo-count {
  margin: 0;
  font-size: 12px;
  color: #666;
  font-weight: 400;
}
</style>
